import _ from 'lodash';
import React, { useMemo } from 'react';
import { Alert, BannerAlertType } from '../../alert';
import { Modal, ModalSize, ModalType } from '../../modal';
import { Stepper } from '../../stepper';
import { Typography } from '../../typography';
import styles from './modal-wizard.module.scss';
export var MODAL_WIZARD_DATA_TESTID;
(function (MODAL_WIZARD_DATA_TESTID) {
    MODAL_WIZARD_DATA_TESTID["ERROR_BANNER_ID"] = "error-banner-id";
    MODAL_WIZARD_DATA_TESTID["STEPPER_CONTAINER"] = "stepper-container";
})(MODAL_WIZARD_DATA_TESTID || (MODAL_WIZARD_DATA_TESTID = {}));
export var WizardModalSize;
(function (WizardModalSize) {
    WizardModalSize["MEDIUM"] = "medium";
    WizardModalSize["LARGE"] = "large";
    WizardModalSize["FULLSCREEN"] = "fullscreen";
})(WizardModalSize || (WizardModalSize = {}));
export const ModalWizard = ({ currentStep, wizardSteps, wizardError, showStepper, stepperProps, isOpen, size, ...restProps }) => {
    const { stepName, stepDescription, stepComponent } = wizardSteps[currentStep];
    const stepperSteps = useMemo(() => wizardSteps.map((step) => ({
        title: step.stepName,
    })), [wizardSteps]);
    let modalSize = ModalSize.MEDIUM;
    if (size === WizardModalSize.LARGE) {
        modalSize = ModalSize.LARGE;
    }
    else if (size === WizardModalSize.FULLSCREEN) {
        modalSize = ModalSize.FULLSCREEN;
    }
    return (React.createElement(Modal, { ...restProps, variant: ModalType.Wizard, size: modalSize, isOpen: isOpen, includesHeader: true, autoScrollContent: false, backButton: undefined, noPadding: true },
        React.createElement("div", { className: styles.wizardBody },
            React.createElement("div", { className: styles.verticalStepperContainer, "data-testid": MODAL_WIZARD_DATA_TESTID.STEPPER_CONTAINER },
                React.createElement(Stepper, { currentStep: currentStep, ...stepperProps, steps: stepperSteps, orientation: "vertical" })),
            React.createElement("div", { className: styles.stepComponentContainer },
                wizardError && (React.createElement(Alert.Banner, { message: wizardError.message, className: styles.errorMessage, isVisible: wizardError.isVisible, type: BannerAlertType.ERROR, showCloseButton: wizardError.showCloseButton || true, onClose: wizardError.onClose || _.noop, "data-testid": MODAL_WIZARD_DATA_TESTID.ERROR_BANNER_ID })),
                stepName && (React.createElement(Typography, { variant: "section-label" }, stepName)),
                stepDescription && (React.createElement(Typography, { variant: "p" }, stepDescription)),
                stepComponent))));
};
//# sourceMappingURL=modal-wizard.js.map